class Filter {
	constructor(group, id, name) {
		this._group = group;
		this._id = id;
		this._name = name;

		this._checkbox = chk('form-check-input');
		onEv(this._checkbox, 'click', _ => document.dispatchEvent(new Event('filterSelected')));

		this._row = div('row', [
			div('col-auto mx-2 my-1', 
				label('form-check', [
					this._checkbox,
					span('form-check-label', this._name)
				])
			)
		]);
	}

	init(data) {
		if (data && data.hasOwnProperty(this._group)) {
		this._checkbox.checked = (this._id == -1 ? false : -1 < data[this._group].indexOf(this._id));
		}
		else {
			this._checkbox.checked = (this._id == -1);
		}
	}

	get group() {return this._group;}

	get id() {return this._id;}

	get row() {return this._row;}

	get isSet() {return this._checkbox.checked;}

	get isAll() {return this._id === -1;}

	set checked(value) {
		this._checkbox.checked = value;
	}

	get checked() {
		return this._checkbox.checked;
	}

	clear() {
		this.checked = false;
	}
}